var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container', _vm._isMobile() ? 'mobile' : '']
  }, [_c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_c('a-form', [_c('a-form-item', {
    attrs: {
      "label": "活动界次",
      "labelCol": {
        xs: {
          span: 8
        },
        sm: {
          span: 2
        }
      },
      "wrapperCol": {
        xs: {
          span: 16
        },
        sm: {
          span: 22
        }
      }
    }
  }, [_c('j-dict-select-tag', {
    attrs: {
      "defaultShowAll": true,
      "type": "radioButton",
      "dictCode": "event_orders",
      "trigger-change": true
    },
    on: {
      "change": _vm.eventChange
    },
    model: {
      value: _vm.queryParam.eventId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "eventId", $$v);
      },
      expression: "queryParam.eventId"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "排序方式",
      "labelCol": {
        xs: {
          span: 8
        },
        sm: {
          span: 2
        }
      },
      "wrapperCol": {
        xs: {
          span: 16
        },
        sm: {
          span: 22
        }
      }
    }
  }, [_c('a-radio-group', {
    attrs: {
      "button-style": "solid"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: _vm.queryParam.orderBy,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "orderBy", $$v);
      },
      expression: "queryParam.orderBy"
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": "star"
    }
  }, [_vm._v(" 推荐 ")]), _c('a-radio-button', {
    attrs: {
      "value": "time"
    }
  }, [_vm._v(" 最新提交 ")]), _c('a-radio-button', {
    attrs: {
      "value": "view"
    }
  }, [_vm._v(" 查看最多 ")])], 1)], 1)], 1), _c('a-divider'), _c('a-list', {
    attrs: {
      "grid": {
        gutter: _vm._isMobile() ? 12 : 24,
        lg: 4,
        md: 3,
        sm: 2,
        xs: 1
      },
      "dataSource": _vm.dataSource,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          staticClass: "work-card"
        }, [_c('a', {
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item.id);
            }
          }
        }, [item.workCover_url ? _c('img', {
          staticClass: "work-cover",
          attrs: {
            "src": item.workCover_url
          }
        }) : _vm._e(), item.workType == 4 ? _c('img', {
          attrs: {
            "src": require("../assets/python.png"),
            "alt": ""
          }
        }) : _vm._e()]), _c('a-row', {
          attrs: {
            "type": "flex",
            "justify": "end"
          }
        }, [_c('a-col', {
          attrs: {
            "span": 5
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "eye"
          }
        }), _vm._v(" " + _vm._s(item.viewNum) + "\n            ")], 1), _c('a-col', {
          attrs: {
            "span": 5
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "like"
          }
        }), _vm._v(" " + _vm._s(item.starNum) + "\n            ")], 1)], 1), _c('p', [_vm._v(_vm._s(item.workName))]), _c('a-row', {
          staticClass: "work-author"
        }, [_c('a-col', {
          attrs: {
            "span": 6
          }
        }, [_c('a-avatar', {
          staticClass: "avatar",
          attrs: {
            "shape": "square",
            "icon": "user",
            "size": 40,
            "src": item.avatar_url
          }
        })], 1), _c('a-col', {
          attrs: {
            "span": 18
          }
        }, [_c('span', [_vm._v(_vm._s(item.realname || item.username))])])], 1)], 1)], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };